import { Link } from '@reach/router';
import { LessonsActivity } from 'api/lessonsApi';
import useFullHeight from 'components/subjectSite/useFullHeight';
import React, { useRef } from 'react';
import LessonDownArrow from './LessonDownArrow';
import { activityImage } from './lessonsHelpers';

type Props = {
  activity: LessonsActivity;
  keyStageName: string;
};

/**
 * The unit page's hero: Back, year chip, title and the activity image
 */
const LessonLandingTop: React.FC<Props> = ({ activity, keyStageName }) => {
  const blockRef = useRef<HTMLDivElement>(null);
  const image = activityImage(activity);

  useFullHeight(blockRef);

  return (
    <div className="Top ContainerFixed" ref={blockRef}>
      <div className="Inner">
        <div className="WidthContent">
          <Link className="BackArrowA" to="/">
            <div className="BackArrow"></div>
            <div className="BackArrowSpan">Back</div>
          </Link>
          <div className="Table">
            <div className="Desc">
              <div className="ImgHidden">
                <img src={image} alt={activity.name} />
              </div>
              <div className="Year">{keyStageName}</div>
              <h1 className="Title">{activity.name}</h1>
            </div>
            <div className="Img">
              <img src={image} alt={activity.name} />
            </div>
          </div>
        </div>
      </div>
      <LessonDownArrow />
    </div>
  );
};

export default LessonLandingTop;
